import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "keyConnect"
const KeyConnectIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.964 19.098c-.053-.156-.183-.286-.504-.607l-5.891-5.89c.99-1.98.006-4.459-2.965-7.42-1.487-1.485-3.466-1.98-6.434.988C1.2 9.137 1.696 11.116 3.18 12.6c2.968 2.968 5.442 3.958 7.424 2.968l.491.495h1.98v1.934h1.978v2.023h1.979V22h1.979c.494 0 .742 0 .865-.124.124-.123.124-.37.124-.865v-1.485c0-.201 0-.32-.036-.428ZM4.874 10.41c.488.489 1.676.092 2.653-.885.977-.977 1.374-2.165.886-2.653-.489-.489-1.677-.092-2.654.885-.977.977-1.374 2.165-.885 2.653ZM15.407 2.035a9.246 9.246 0 0 1 6.568 7.557.84.84 0 1 1-1.664.24 7.565 7.565 0 0 0-5.374-6.183.84.84 0 0 1 .47-1.614Zm-.94 3.228a5.884 5.884 0 0 1 4.18 4.81.84.84 0 0 1-1.664.24 4.203 4.203 0 0 0-2.986-3.436.84.84 0 1 1 .47-1.614Z"
      />
    </svg>
  )
}
export default KeyConnectIcon
